import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  TAgentChatbot,
  TCreateChatbotSettingsPayload,
} from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const useUpdateChatbotSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: TCreateChatbotSettingsPayload) =>
      HttpService.put<TAgentChatbot>({
        path: EServerPath.chatbotSettings,
        payload: params,
      }),
    onSuccess: (_, variables) => {
      const { agentId } = variables
      queryClient.invalidateQueries({
        queryKey: queryKeys.chatbotSettings(agentId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.agents({}),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.agentsByOrganization(''),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminAgents({}),
      })
    },
    onError: () => {
      toast.error('Error updating chatbot settings. Please try again later.')
    },
  })
}

export default useUpdateChatbotSettings
